<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.add_cities' | translate }} </h3>

  <form #jobTitleForm="ngForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
  <div class="row">

     <!-- Nationality -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.nationality' | translate }}</label>
   
             <select
                class="form-control"
                [class.is-invalid]="country_id.invalid && country_id.touched"
                [(ngModel)]="formData.country_id"
                name="country_id" #country_id="ngModel"
                  
                required
              >
                <option value="" disabled selected>
                  {{ 'MENU.DASHBOARD.select_countries' | translate }}
                </option>
                <option *ngFor="let title of countries" [value]="title.id">
                               {{ title.name }}

              
                </option>
              </select>
            <div *ngIf="country_id.invalid && country_id.touched" class="text-danger small mt-1">
              <div *ngIf="country_id.errors?.['required']">{{ 'MENU.DASHBOARD.nationality_required' | translate }}</div>
              <div *ngIf="country_id.errors?.['minlength']">{{ 'MENU.DASHBOARD.nationality_min_length' | translate }}</div>
            </div>
          </div>
        </div>

    <!-- Job Title (English) -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">
          {{ 'MENU.DASHBOARD.cities_name_en' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_cities_name_en' | translate }}"
          [(ngModel)]="formData.name_en"
          name="name_en"
          required
          #nameEn="ngModel"
        />
        <!-- Validation Message -->
        <div *ngIf="nameEn.invalid && nameEn.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.cities_name_en_required' | translate }}
        </div>
      </div>
    </div>

    <!-- Job Title (Arabic) -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">
          {{ 'MENU.DASHBOARD.cities_name_ar' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_cities_name_ar' | translate }}"
          [(ngModel)]="formData.name_ar"
          name="name_ar"
          required
          #nameAr="ngModel"
        />
        <!-- Validation Message -->
        <div *ngIf="nameAr.invalid && nameAr.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.cities_name_ar_required' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Submit + Cancel -->
  <div class="text-start mt-3">
    <button
      type="submit"
      class="btn btn-suc px-3"
      [disabled]="jobTitleForm.invalid"
    >
      {{ 'MENU.DASHBOARD.add_cities' | translate }}
    </button>

    <button
      type="button"
      class="btn btn-secondary ms-2 mx-2 px-3"
      (click)="cancel()"
    >
      {{ 'MENU.DASHBOARD.cancel' | translate }}
    </button>
  </div>
</form>

  </div>
</div>
